import * as types from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState = false;

const reset = () => initialState;

const isReady = () => true;

export default createReducer(initialState, {
  [types.SEND_CHECKOUT_READY]: isReady,
  [types.OPEN_SEND_WIZARD]: reset,
  [types.CLOSE_SEND_WIZARD]: reset,
});
